import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '*',
    redirect: '/'
  },
  {
    name: 'buy',
    path: '/buy/:goodsId/',
    component: () => import('./view/buy'),
    meta: {
      title: '购买页'
    }
  },
  {
    name: 'index',
    path: '/',
    component: () => import('./view/index'),
    meta: {
      title: '斗K双十一预售'
    }
  },
  {
    name: 'goods',
    path: '/goods/:goodsId/',
    props: true,
    component: () => import('./view/goods'),
    meta: {
      title: '商品详情'
    }
  }
];

// add route path
routes.forEach(route => {
  route.path = route.path || '/' + (route.name || '');
});

function scrollBehavior () {
  return { x: 0, y: 0 }
}

const router = new Router({ routes, scrollBehavior });
// const router = new Router({ routes });

router.beforeEach((to, from, next) => {
  const title = to.meta && to.meta.title;
  if (title) {
    document.title = title;
  }
  next();
});

// router.onReady(function (params) {
//   console.log(JSON.stringify(params, null, 2))
// })

export {
  router
};
